import * as React from "react";

export const WarrantyHelperText = () => {
  return (
    <ul>
      <li>
        MFR and L&D warranty dates will be adjusted based on the selected
        Delivered At date.
      </li>
    </ul>
  );
};
